import Lookup from 'src/componentes/select2';
import CalendarioEdit from 'src/paginas/calendario/edit';

const CalendarioLookup = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/CalendarioLookup"
      editComponent={CalendarioEdit}
      {...props}
    />
  );
};

export default CalendarioLookup;
